import React, { useState, useEffect } from "react";
import { Button, Form, Input, Select, Checkbox, Col, Row, Spin } from "antd";
import axios from "axios";
import logoHeader from "../images/logo_header.png";
import Mai from "../images/mars-logo.png";
import { ReloadOutlined, LoadingOutlined } from "@ant-design/icons";
import swal from "sweetalert";
import $ from "jquery";
import { BASE_URL } from "../utils/BASE_URL";
import "../cs/fb.css";
const FB = () => {
  const [isCustomerDetailsVisible, setIsCustomerDetailsVisible] =
    useState(false);
  const [isSubmittedBy, setIsSubmittedBy] = useState(true);

  const [callReasons, setCallReasons] = useState([]);
  const [PriorityList, setPriorityList] = useState([]);
  const [technicianList, setTechnicianList] = useState([]);
  const [CustomerData, setcustomerData] = useState([]);
  const [captchaInput, setCaptchaInput] = useState("");
  const [submittedBy, setSubmittedBy] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [isCaptchaMatched, setIsCaptchaMatched] = useState(false);

  const [form] = Form.useForm();
  const [fb_form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const { Option } = Select;

  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [isTechnicianFieldVisible, setIsTechnicianFieldVisible] =
    useState(false);

  function generateCaptcha() {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  const refreshCaptcha = () => {
    setCaptcha(generateCaptcha());
    setIsCaptchaMatched(false);
  };

  const handleCaptchaChange = (e) => {
    const input = e.target.value;
    setCaptchaInput(input);
    setIsCaptchaMatched(input === captcha);
  };

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsTechnicianFieldVisible(isChecked);
    if (isChecked) {
      const apiUrlGetTechnicians = `${BASE_URL}Home/GetTechnicians?PostalCode=${CustomerData.PostalCode}`;
      setLoading(true);

      axios
        .get(apiUrlGetTechnicians, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          setLoading(false);
          console.log("API Response:", response.data);
          setTechnicianList(response.data.Data);
        })
        .catch((error) => {
          console.error("API Error:", error);
          setLoading(false);
        });
    }
  };

  const onValuesChange = (changedValues, allValues) => {
    const { userName, customerId } = allValues;
  };
  const onFinish = (values) => {
    console.log("Form values:", values);
    setSubmittedBy("");
    setCustomerId("");
    setCaptchaInput("");
    setCaptcha(generateCaptcha());
    fb_form.resetFields();
    setIsTechnicianFieldVisible(false);

    const { userName, customerId } = values;

    setSubmittedBy(userName);
    setCustomerId(customerId);
    const apiUrlCustomerExist = `${BASE_URL}Home/CustomerExist?customerId=${customerId}&userName=${userName}`;

    setLoading(true);

    axios
      .get(apiUrlCustomerExist, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("API Response:", response.data);

        if (response.data.responseCode === 500) {
          swal({
            text: response.data.responseMessage,
            icon: "warning",
          }); // Display the responseMessage with a warning icon
          setLoading(false);
        } else if (response.data.responseCode) {
          setIsCustomerDetailsVisible(true);
          setCallReasons(response.data.Data.CallReasonsList);
          setPriorityList(response.data.Data.PriorityList);
          setcustomerData(response.data.Data.customerData);
          setIsSubmittedBy(false);
          setIsCustomerDetailsVisible(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
      });
  };

  const handleBack = () => {
    setIsSubmittedBy(true);
    setIsCustomerDetailsVisible(false);
  };

  const onFinishCalll = async (values) => {
    console.log("Call Details Form values:", values);
    console.log("Customer ID:", customerId);
    console.log("Submitted By:", submittedBy);

    const apiUrl = `${BASE_URL}Workorder/SaveEvent`;

    let data = {
      CustomerID: customerId,
      SubmittedBy: submittedBy,
      CallReason: values.callReason,
      EquipmentLocation: values.equipmentLocation,
      CallerName: values.callerName,
      WorkorderContactPhone: values.phone,
      PriorityCode: values.priority,
      CustomerZipCode: CustomerData.PostalCode,
      IsSpecificTechnician: values.technician ? "true" : "false",
      PreferredProvider: values.technician || 0,
      Notes: values.notes,
    };

    console.log("Payload:", data);

    setLoading(true);

    await $.ajax({
      url: apiUrl,
      data: data,
      method: "post",
      success: function (response) {
        if (response.success) {
          swal(
            "Success",
            `Work Order ID: ${response.WorkOrderId}`,
            "success"
          ).then(() => {
            setIsCustomerDetailsVisible(false);
            setSubmittedBy("");
            setCustomerId("");
            setCaptchaInput("");
            setCaptcha(generateCaptcha());
            form.resetFields();
            fb_form.resetFields();
            setIsSubmittedBy(true);
            setLoading(false);
            setIsTechnicianFieldVisible(false);
          });
        } else {
          swal("Error", response.message || "An error occurred", "error");
        }
      },
    });
  };

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "rgb(87, 38, 0)" }} spin />
  );

  return (
    <div
      className="container"
      style={{ backgroundColor: "#faf8f0", padding: "0" }}
    >
      <div
        style={{
          backgroundColor: "#572600",
          padding: "10px 0",
          position: "sticky",
          top: "0",
          zIndex: "1000", // Ensures it stays above other content when scrolling
        }}
      >
        <Row
          align="middle"
          style={{
            width: "100%",
            margin: "0",
            padding: "10px 0",
            backgroundColor: "#572600",
          }}
        >
          <Col flex="none" style={{ textAlign: "center", padding: "0 10px" }}>
            <img
              src={logoHeader}
              alt="Farmer Brothers"
              style={{ width: "80px" }}
            />
          </Col>
          <Col flex="auto" style={{ textAlign: "center" }}>
            <span
              style={{
                color: "white",
                fontSize: "clamp(14px, 3vw, 24px)",
                fontWeight: "bold",
                fontFamily: "Arial, sans-serif",
                textTransform: "uppercase",
              }}
            >
              FARMER BROTHERS CUSTOMER SERVICE PORTAL
            </span>
          </Col>
          <Col flex="none" style={{ textAlign: "center", padding: "0 10px" }}>
            <span
              style={{
                color: "white",
                fontSize: "clamp(12px, 2vw, 18px)",
                fontFamily: "Arial, sans-serif",
              }}
            >
              877-322-6885
            </span>
          </Col>
          <Col flex="none" style={{ textAlign: "center", padding: "0 10px" }}>
            <img src={Mai} alt="Mars" style={{ width: "80px" }} />
          </Col>
        </Row>
      </div>

      {isSubmittedBy && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "14px",
            width: "100%",
          }}
        >
          <Form
            form={form}
            onFinish={onFinish}
            onValuesChange={onValuesChange}
            layout="horizontal"
          >
            <Row gutter={16} align="middle" style={{ padding: "0 15px" }}>
              <Col>
                <Form.Item
                  label={
                    <span>
                      Submitted By<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="userName"
                  required={false}
                  rules={[{ required: true, message: "Submitted By Required" }]}
                >
                  <Input
                    placeholder="Submitted By"
                    size="small"
                    style={{ width: "150px" }}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item
                  label={
                    <span>
                      Account Number<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="customerId"
                  required={false}
                  rules={[
                    { required: true, message: "Account Number Required" },
                  ]}
                >
                  <Input
                    placeholder="Account Number"
                    maxLength={10}
                    size="small"
                    style={{ width: "150px" }}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="middle"
                    style={{
                      backgroundColor: "#65310E",
                      borderColor: "#65310E",
                      color: "white",
                      width: "150px",
                    }}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      )}

      <div style={{ marginTop: "-24px" }}>
        <Spin
          spinning={loading}
          indicator={antIcon}
          tip={<span style={{ color: "rgb(87, 38, 0)" }}>Loading...</span>}
        >
          {isCustomerDetailsVisible && (
            <div
              style={{
                backgroundColor: "#faf8f0",
                height: "100vh",
                padding: "0",
                minHeight: 'fit-content',
                overflowY: 'scroll'
              }}
            >
              <div style={{ padding: "10px" }}>
                <h3
                  style={{
                    color: "#8b0000",
                    marginBottom: "0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "clamp(14px, 3vw, 24px)",
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                  }}
                >
                  Customer
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "clamp(14px, 3vw, 24px)",
                      fontWeight: "bold",
                      fontFamily: "Arial, sans-serif",
                    }}
                  >
                    Required Fields<span style={{ color: "red" }}>*</span>
                    <Button
                      onClick={handleBack}
                      style={{
                        backgroundColor: "#65310E",
                        borderColor: "#65310E",
                        color: "white",
                        marginLeft: "10px",
                      }}
                    >
                      Back
                    </Button>
                  </span>
                </h3>

                <hr style={{ border: "none", borderTop: "1px solid #ccc" }} />
                <Row
                  gutter={[16, 16]} // Adds a 16px gap between columns horizontally and vertically
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                    <div>
                      <strong>Account Number:</strong>{" "}
                      <span>{CustomerData.ContactID}</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                    <div>
                      <strong>Customer Name:</strong>{" "}
                      <span>{CustomerData.CompanyName}</span>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={10} xl={10}>
                    <div>
                      <strong>ADDRESS, CITY, STATE POSTAL CODE:</strong>{" "}
                      <span>
                        {CustomerData.Address1}, {CustomerData.City},{" "}
                        <span style={{ marginRight: "10px" }}>
                          {CustomerData.State}
                        </span>
                        {CustomerData.PostalCode}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>

              <div style={{ padding: "10px" }}>
                <h3
                  style={{
                    color: "#8b0000",
                    marginBottom: "0",
                    fontSize: "clamp(14px, 3vw, 24px)",
                    fontWeight: "bold",
                    fontFamily: "Arial, sans-serif",
                  }}
                >
                  Call Details
                </h3>
                <hr style={{ border: "none", borderTop: "1px solid #ccc" }} />

                <Form
                  layout="vertical"
                  onFinish={onFinishCalll}
                  style={{ padding: "10px" }}
                >
                  <Row gutter={16} align="middle" justify="start">
                    <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                      <Form.Item
                        label={
                          <span>
                            Call Reason:<span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="callReason"
                        required={false}
                        rules={[
                          { required: true, message: "Call Reason Required" },
                        ]}
                      >
                        <Select
                          placeholder="Please Select Call Reason"
                          showSearch
                          optionFilterProp="children"
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {callReasons.map((reason) => (
                            <Option
                              key={reason.CallTypeID}
                              value={reason.CallTypeID}
                            >
                              {reason.Description}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                      <Form.Item
                        label={
                          <span>
                            Caller Name:<span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="callerName"
                        required={false}
                        rules={[
                          { required: true, message: "Caller Name Required" },
                        ]}
                      >
                        <Input placeholder="Caller Name" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                      <Form.Item
                        label={
                          <span>
                            Priority:<span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="priority"
                        required={false}
                        rules={[
                          { required: true, message: "Priority Required" },
                        ]}
                      >
                        <Select
                          placeholder="Please Select Priority"
                          showSearch
                          optionFilterProp="children"
                          allowClear
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                        >
                          {PriorityList.map((priority) => (
                            <Option
                              key={priority.FBStatusID}
                              value={priority.FBStatusID}
                            >
                              {priority.FBStatus}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={5} xl={5}>
                      <Form.Item label="Contact Phone Number:" name="phone">
                        <Input placeholder="Contact Phone Number" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} xl={4}>
                      <Form.Item
                        label={
                          <span>
                            Equipment Location:
                            <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        name="equipmentLocation"
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: "Equipment Location Required",
                          },
                        ]}
                      >
                        <Input placeholder="Equipment Location" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                      <Form.Item
                        label={
                          <span>
                            Notes:
                            <span style={{ color: "red" }}>*</span>{" "}
                          </span>
                        }
                        name="notes"
                        required={false}
                        rules={[
                          {
                            required: true,
                            message: "Notes Required",
                          },
                        ]}
                      >
                        <Input.TextArea rows={4} style={{ width: "100%" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={20} align="middle" wrap>
                    <Col
                      xs={24}
                      sm={12}
                      md={8}
                      style={{ display: "flex", justifyContent: "flex-start" }}
                    >
                      {/* Checkbox and Technician Selection */}
                      <Form.Item
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <Checkbox onChange={handleCheckboxChange}>
                          FB Employee Requesting Specific Technician
                        </Checkbox>
                      </Form.Item>
                      {isTechnicianFieldVisible && (
                        <Form.Item
                          label={
                            <span>
                              Technician<span style={{ color: "red" }}>*</span>
                            </span>
                          }
                          name="technician"
                          required={false}
                          rules={[
                            { required: true, message: "Technician Required" },
                          ]}
                        >
                          <Select
                            placeholder="Please Select Technician"
                            style={{ width: "100%" }}
                            showSearch
                            optionFilterProp="children"
                            allowClear
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {technicianList.map((technician) => (
                              <Option
                                key={technician.TechID}
                                value={technician.TechID}
                              >
                                {technician.PreferredProvider}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      )}
                    </Col>

                    <Col
                      xs={18}
                      sm={12}
                      md={15}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        minHeight: "0px",
                        alignItems:'center',
                        gap:'8px'
                      }}
                    >
                      <Form.Item
                        name="captchaInput"
                        label={
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap:'8px'
                            }}
                          >
                            <div>
                              Captcha:<span style={{ color: "red" }}>*</span>
                            </div>

                            <div>
                              <span style={{backgroundColor:'#e0e0e0', borderRadius:"8px",fontWeight:'bold'}}>{captcha}</span>
                              <Button
                                onClick={refreshCaptcha}
                                icon={
                                  <ReloadOutlined
                                    style={{ color: "green", fontSize: "16px" }}
                                  />
                                }
                                size="small"
                              />
                            </div>
                          </div>
                        }
                        rules={[
                          {
                            validator: () =>
                              isCaptchaMatched
                                ? Promise.resolve()
                                : Promise.reject("CAPTCHA does not match"),
                          },
                        ]}
                        style={{ width: "220px" }}
                      >
                        <Input
                          placeholder="Type the code shown"
                          value={captchaInput}
                          onChange={handleCaptchaChange}
                          style={{
                            width: "100%",
                            height: "33px",
                          }}
                        />
                      </Form.Item>

                      <div style={{ marginLeft: "6px" }}>
                        <Button
                          type="primary"
                          style={{
                            backgroundColor: "#65310E",
                            borderColor: "#65310E",
                            color: "white",
                          }}
                          htmlType="submit"
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          )}
        </Spin>
      </div>
      <footer
        style={{
          textAlign: "center",
          backgroundColor: "#572600",
          color: "white",
          padding: "10px 0",
          position: "fixed",
          bottom: 0,
          width: "100%",
          fontSize: "12px", // Adjust the size as needed
        }}
      >
        Copyright © 2024 Marketing Alternatives Inc. All rights reserved.
      </footer>
    </div>
  );
};

export default FB;
